import _ from 'underscore';

var FILTER_METADATA = 'edge.aspects.validation.dto.TypelistFilterDTO';
var CATEGORY_METADATA = 'edgec10.aspects.validation.dto.CategoryFilterDTO';
var EXPLICIT_LISTS = 'edgec10.aspects.validation.dto.TypekeyListFilterDTO';

/** This aspect defines a list of available values for the field based on the field type
 * and property metadata.
 *
 * @param {Object} expressionLanguage
 *
 * @returns {Object}
 */
function create(expressionLanguage) {
    function compileCategory(compilationContext, node, parent, category) {
        var expr = compilationContext.compile(category.categoryExpression);
        return function () {
            return expr(node, parent, node.aspects.context);
        };
    }

    /**
     * Checks if two lists matches each other.
     *
     * @param {Array|*} arr1
     * @param {Array|*} arr2
     *
     * @returns {Boolean}
     */
    function matches(arr1, arr2) {
        if (arr1 === null !== (arr2 === null)) {
            return false;
        }

        if (arr1.length !== arr2.length) {
            return false;
        }

        for (var i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }

        return true;
    }

    return {
        'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
            if (currentMetadataNode.valueType.kind !== 'class') {
                return {};
            }

            var typeInfo = currentMetadataNode.valueType.typeInfo;
            if (!typeInfo.metaType.isTypelist) {
                return {};
            }

            var baseValues = typeInfo.codes;

            var filterRules = currentMetadataNode.elementMetadata.get(FILTER_METADATA);

            filterRules.forEach(function (filterName) {
                var filter = typeInfo.getFilter(filterName.filterName);
                baseValues = baseValues.filter(filter.allows);
            });

            var explicitLists = currentMetadataNode.elementMetadata.get(EXPLICIT_LISTS);
            explicitLists.forEach(function (explicitList) {
                baseValues = baseValues.filter(function (value) {
                    return explicitList.codes.indexOf(value.code) >= 0;
                });
            });

            var categoryRules = currentMetadataNode.elementMetadata.get(CATEGORY_METADATA);
            if (categoryRules.length === 0) {
                return {
                    'availableValues': {
                        'value': baseValues
                    }
                };
            }

            var compilationContext = expressionLanguage.getCompilationContext(currentMetadataNode.xCenter);

            var parent = ancestorChain.parent || {};
            var categoryExprs = categoryRules.map(_.partial(compileCategory, compilationContext, currentViewModelNode, parent));

            var res = null;

            return {
                'availableValues': {
                    'get': function get() {
                        var newValues = baseValues.filter(function (typekey) {
                            return categoryExprs.every(function (categoryExpr) {
                                var cat = categoryExpr();
                                return !cat || typekey.belongsToCategory(cat);
                            });
                        });

                        /** This is a work around for Angular. It does not have a propagation/dependency tracking.
                         * At the same time it does not consider two arrays with the same content equivalent. So we have
                         * to return the same array to prevent infinite update loops.
                         */
                        if (!matches(newValues, res)) {
                            res = newValues;
                        }

                        return res;
                    }
                }
            };
        }
    };
}

export default {
    create: create
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/aspects/AvailableValues.js
// module id = 935
// module chunks = 0